import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import SEO from "../components/SEO";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/site";

export default function NotFound() {
    return (
        <div data-testid="not-found-page">
            <SEO
                title="Page introuvable | Serrurier Paris"
                description="Cette page n'existe pas ou plus. Retrouvez nos services de serrurerie à Paris et en Île-de-France depuis l'accueil."
                path="/404"
                noIndex
            />
            <section className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 py-24 text-center sm:px-6">
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-emergency">Erreur 404</p>
                <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                    Cette page n'existe pas.
                </h1>
                <p className="mt-6 max-w-md leading-relaxed text-midnight/60">
                    Le lien est peut-être obsolète ou l'adresse mal orthographiée. Retrouvez nos services et zones
                    d'intervention depuis l'accueil, ou appelez-nous directement.
                </p>
                <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
                    <Link
                        to="/"
                        data-testid="not-found-home-link"
                        className="bg-midnight px-7 py-4 font-bold text-white transition-colors hover:bg-emergency"
                    >
                        Retour à l'accueil
                    </Link>
                    <a
                        href={PHONE_TEL}
                        data-testid="not-found-call-button"
                        className="flex items-center gap-3 bg-emergency px-7 py-4 font-bold text-white transition-colors hover:bg-emergency-dark"
                    >
                        <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
                    </a>
                </div>
            </section>
        </div>
    );
}
